import React from "react";

import { useFormInfoContext } from "@utils/forms/formInfo.provider";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { FormText } from "@components/General/Form/formText.component";

import "./microCopy.scss";

type Props = {
    fieldId: string;
};

const MicroCopy = ({ fieldId }: Props) => {
    const microCopyContext = useFormInfoContext();
    const { t } = useGranite();

    if (microCopyContext?.formId && fieldId) {
        const translationKey = `form.microcopy.${microCopyContext.formId}.${fieldId}`;
        const translation = t(translationKey);

        if (translation) {
            return (
                <FormText inline={true} color="default" className="micro-copy">
                    {translation}
                </FormText>
            );
        }
    }

    return <React.Fragment />;
};

export { MicroCopy };
